<div *ngIf="isMobile" >
  <h5 class="mobile-nav-title" i18n>Add Lead</h5>
  <div class="mb-5 mx-3">
    <app-project-info projectType="lead"></app-project-info>
  </div>
</div>

<div *ngIf="!isMobile" class="container-fluid">
  <app-header titleText="LEADS" progressBarState="lead"></app-header>

  <div class="card bg-light">
    <div class="card-header">
      <img src="assets/img/circle_images/leads_circle.png" alt="Customer Icon" class="card-icon" />
      <h5 i18n>Add New Lead</h5>
      <p i18n>Edit lead information below.</p>
    </div>
    <div class="card-body">
      <app-project-info projectType="lead"></app-project-info>
    </div>
  </div>
</div>
